import cx from 'classnames';
import { CircularProgress } from './';
import { GeneratingLoadingUI } from '../screens/NewProductUIV2/ProductComponent';

export default function Loader(props) {
  const {
    hideLoader = false,
    loading,
    color,
    borderColor = null,
    thickness,
    position,
    as,
    size,
    children,
    className,
    style,
    backdrop,
    hideLoadingText = true,
    hideProgressBar = true,
    loadingText,
    isV2 = false,
    loaderStyle = {},
    progressBarStyle = {},
    progressBarTextStyle = {},
    progress = -1,
    bgOpacity,
    textOpacity,
    ...rest
  } = props;

  if (!loading && !children) return null;

  const Component = as || 'div';

  if (isV2)
    return (
      <GeneratingLoadingUI
        {...{
          hideLoader,
          loading,
          hideLoadingText,
          loadingText,
          hideProgressBar,
          progress,
          loaderStyle,
          style,
          bgOpacity,
          textOpacity,
          progressBarStyle,
          progressBarTextStyle,
        }}
      />
    );

  return (
    <Component
      {...rest}
      className={cx('loaderV2', !children && backdrop && 'backdrop', className)}
      style={{
        position,
        ...style,
      }}>
      {loading && (
        <div className="progressContainer">
          <CircularProgress size={size} color={color} thickness={thickness} borderColor={borderColor} />
        </div>
      )}
      {children}
    </Component>
  );
}
